export default function getUniqueIdFromTime() {
  return new Date().getTime().toString(8);
}
